import useFadeIn from '@hooks/useFadeIn'
import './Testimonials.scss'

const REVIEWS = [
  {
    text: 'Sachetele sunt absolut minunate! Dulapul meu miroase divin de săptămâni întregi. Arată și superb, ca o lucrare de artă.',
    name: 'Andreea M. — Cluj',
  },
  {
    text: 'Am cumpărat setul cadou pentru mama și a fost îndrăgostită instantaneu. Ambalajul este superb, parcă e de la un magazin de lux.',
    name: 'Raluca D. — București',
  },
  {
    text: 'Wax melts-urile cu bujor sunt cele mai bune pe care le-am mirosit vreodată. Parfumul este subtil dar persistent, umplu toată camera.',
    name: 'Ioana P. — Timișoara',
  },
]

function TestimonialCard({ text, name, delay }) {
  const ref = useFadeIn()
  return (
    <div className="testi-card fade-up" ref={ref} style={{ transitionDelay: `${delay}s` }}>
      <div className="testi-quote">&ldquo;</div>
      <div className="stars">★★★★★</div>
      <p className="testi-text">{text}</p>
      <div className="testi-name">{name}</div>
    </div>
  )
}

export default function Testimonials() {
  return (
    <section className="testimonials" id="recenzii">
      <div className="section-label">Recenzii</div>
      <h2 className="section-title">
        Ce spun <em>clienții</em> noștri
      </h2>

      <div className="testi-grid">
        {REVIEWS.map((r, i) => (
          <TestimonialCard key={i} {...r} delay={i * 0.12} />
        ))}
      </div>
    </section>
  )
}
